import withRipple from './withRipple';

export { default } from './Ripple';

export { withRipple };
